import {VoucherBaseModel} from "../voucher-base.model";

export class FreePlayVoucherModel extends VoucherBaseModel {
    get voucherName(): string {
        return this.services.translation.translate('FREE_PLAY_VOUCHER_NAME_FPV');
    }

    get voucherDescription(): string {
        return this.services.translation.translate('FREE_PLAY_VOUCHER_DESC_FPV');
    }

    get voucherInGameTitle(): string {
        return this.services.translation.translate('FREE_PLAY_VOUCHER_TITLE_FPV');
    }

    protected _formatVoucherAmount(amount: number): string {
        return this.services.currency.formatMoney(amount, true);
    }

    get backgroundImageUrl(): string {
        return this.services.theme.currentTheme.images.freePlay.backgroundTypeFP.toString();
    }

    get iconUrl(): string {
        return this.services.theme.currentTheme.images.freePlay.typeFP.toString();
    }

}